import { Injectable, inject } from "@angular/core";
import { ITranslateObject, JobsBillingCard } from "../views-interfaces";
import { SingleSelectModel, Option } from "@app/filter-menu/filter-types";
import { TranslateService } from "@ngx-translate/core";
import { WkDateFormat } from "./date-format";

@Injectable()
export class TargetStartFilterGeneratorService {
    private readonly translateService = inject(TranslateService);
    generateModel(selection: string = "") {
        const allOptions: Option[] = [
            { text: "FiltersSidebar.Options.Dates.All", value: "all" },
            { text: "FiltersSidebar.Options.Dates.None", value: "none" },
            { text: "FiltersSidebar.Options.Dates.DueOn", value: "dueOn" },
            { text: "FiltersSidebar.Options.Dates.DateRange", value: "dateRange" },
        ];

        return {
            label: "FiltersSidebar.Labels.TargetStart",
            allOptions,
            applicableOptions: allOptions,
            selection: allOptions.find((option) => option.value === selection) || allOptions[0],
        } as SingleSelectModel;
    }

    getPrintDescription(
        label: string | ITranslateObject,
        selectedOption: Option,
        from: string,
        to: string,
    ): { label: string | ITranslateObject; values: (string | ITranslateObject)[] } | null {
        const value = selectedOption?.value;
        if (!value || value === "all") return null;
        if (value === "none") return { label, values: ["FiltersSidebar.Options.Dates.None"] };
        if (value === "dueOn") {
            const formatted = WkDateFormat.toYYYYMMDD(from);
            if (!formatted) return null;
            return { label, values: [formatted] };
        }
        const fromFormatted = WkDateFormat.toYYYYMMDD(from);
        const toFormatted = WkDateFormat.toYYYYMMDD(to);
        if (!fromFormatted && !toFormatted) return null;
        const notApplicable = this.translateService.instant("FiltersSidebar.Labels.DateNotApplicable");
        return { label, values: [`(${fromFormatted || notApplicable} - ${toFormatted || notApplicable})`] };
    }

    generateFilter(selectedValue: string, from: string, to: string) {
        if (!selectedValue || selectedValue === "all") return null;
        if (selectedValue === "none") {
            return (card: JobsBillingCard) => !card?.job?.targetStartDate || card.job.targetStartDate === 0;
        }
        const endText = selectedValue === "dueOn" ? from : to;
        const fromEpoch = WkDateFormat.toStartOfDayEpochSeconds(from);
        const toEpoch = WkDateFormat.toEndOfDayEpochSeconds(endText);
        if (fromEpoch === null && toEpoch === null) return null;
        return (card: JobsBillingCard) => {
            const cardDate = card?.job?.targetStartDate;
            if (!cardDate || cardDate === 0) return false;
            if (fromEpoch !== null && cardDate < fromEpoch) return false;
            if (toEpoch !== null && cardDate > toEpoch) return false;
            return true;
        };
    }
}
